export const constantVar = {
  numberPatten: /\d/g,
};

export const bookingType = [
  {
    label: "Single Booking",
    value: "Single Booking"
  },
  {
    label: "Multiple Booking",
    value: "Multiple Booking"
  }
]

